function dateAtLocalMidnight(dateString) {
  const [year, month, day] = dateString.split("-").map(Number);
  return new Date(year, month - 1, day);
}

function archiveMonth(dateString) {
  return dateString.slice(0, 7);
}

function startOfToday(referenceDate) {
  const today = new Date(referenceDate);
  today.setHours(0, 0, 0, 0);
  return today;
}

export function upcomingEvents(events, referenceDate = new Date()) {
  const today = startOfToday(referenceDate);

  return events
    .filter((event) => dateAtLocalMidnight(event.date) >= today)
    .sort((first, second) => dateAtLocalMidnight(first.date) - dateAtLocalMidnight(second.date));
}

export function archivedEventsByMonth(upcoming, archivedByMonth = [], referenceDate = new Date()) {
  const today = startOfToday(referenceDate);
  const eventsById = new Map();

  archivedByMonth.forEach((group) => {
    group.events.forEach((event) => eventsById.set(event.id, event));
  });
  upcoming
    .filter((event) => dateAtLocalMidnight(event.date) < today)
    .forEach((event) => eventsById.set(event.id, event));

  const months = new Map();
  eventsById.forEach((event) => {
    const month = archiveMonth(event.date);
    months.set(month, [...(months.get(month) || []), event]);
  });

  return [...months.entries()]
    .sort(([first], [second]) => second.localeCompare(first))
    .map(([month, events]) => ({
      month,
      events: events.sort((first, second) => dateAtLocalMidnight(first.date) - dateAtLocalMidnight(second.date)),
    }));
}